import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';
import { TrackingLink } from './BtLink';
import { useShipmentData } from './DataProviders';


const useStyles = makeStyles({
  icon: {
    fontSize: '0.8rem'
  }
});


export default function TrackingNumberLink({ onClick, className }) {
  const { tracking_number, tracking_url } = useShipmentData();
  const classes = useStyles();
  const href = onClick ? undefined : tracking_url;

  return (
    <TrackingLink className={className} onClick={onClick} href={href} data-testid="tracking-number-link">
      {tracking_number} <Icon icon={faExternalLinkAlt} className={`${classes.icon} external-link`} />
    </TrackingLink>
  );
}
